export default function getJamFilledCookie(): string {
	try {
		const v = document.cookie.match(
			"(^|;) ?" + "jam_filled_cookie" + "=([^;]*)(;|$)",
		)
		let cookie = v ? v[0] : null
		if (!cookie) throw new Error("no cookie")
		cookie = cookie.split(", domain=")[0]
		if (cookie.includes("; ")) return cookie.replace("; ", "")
		return cookie
	} catch (e) {
		return "jam_filled_cookie=false"
	}
}
